export default __webpack_public_path__ + "static/media/bannerlogo.2cfe036b.png";